import { Info, Link } from "lucide-react";
import React, { useState } from "react";
import { toast } from 'sonner';
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { Drawer, DrawerContent } from "../../components/ui/drawer";
import { Toaster } from "../../components/ui/toaster";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../components/ui/tooltips";
import ReferralStep from "./ReferralStep";


const Referral: React.FC = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  
  const actions: {
    title: string;
    onClick: () => void;
    icon?: React.FC<{ className?: string }>;
    image?: string;
  }[] = [
    {
      title: 'Copy link',
      onClick: () => {
        const link = 'https://example.com/invite?referralCode=12345';
        navigator.clipboard.writeText(link);
        toast.success('Link copied to clipboard!');
        // setOpenDrawer(false);
      },
      icon: Link
    },
    // {
    //   title: 'WhatsApp',
    //   onClick: () => {
    //     console.log('Share via WhatsApp clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/whatsapp.png',
    // },
    // {
    //   title: 'Messenger',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/messenger.png',
    // },
    // {
    //   title: 'Telegram',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/telegram.png',
    // },
    // {
    //   title: 'Instagram Direct',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/instagram.png',
    // },
    // {
    //   title: 'SMS',
    //   onClick: () => {
    //     console.log('Share via Messenger clicked');
    //     setOpenDrawer(false);
    //   },
    //   image: '/assets/images/sms.png',
    // },
  ]

  const handleInviteFriend = () => {
    console.log('Invite a friend clicked');
    setOpenDrawer(true);
  }
  
  return (
    <>
      <div className="min-h-[80vh] p-6">
        <h3 className="font-semibold mb-4">Refer & Earn</h3>

        <div className="flex flex-col justify-center items-center gap-4 mb-12">
          <div className="mx-auto">
            <img src="/assets/referral-hero.png" alt="referral hero" className="h-44"/>
          </div>

          <p className="text-sm text-center">
            Refer your friends & family to earn [amount] [r type] EACH when they sign up and spent with AyeFace
          </p>

          <Button className="w-full max-w-72 sm:max-w-96" onClick={handleInviteFriend}>Invite a friend</Button>
        </div>

        <Card className="shadow-lg pt-4">
          <CardContent className="flex flex-col items-center">
            <h3 className="flex gap-2 items-center">
              My referrals
              <TooltipProvider>
                <Tooltip delayDuration={0}>
                  <TooltipTrigger asChild>
                    <Info className="h-4 w-4 text-gray-500 cursor-help" />
                  </TooltipTrigger>
                  <TooltipContent side="top" className="w-56 bg-[#F3F3F3]">
                    <p className='text-xs font-extralight text-[#101B2C]'>
                      Referral rewards will only be issued after the referrals have completed at least a transaction with AyeFace
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </h3>

            <div className="grid grid-cols-2 mt-4 w-full">
              <div className="flex flex-col items-center border-r-1 w-full py-2">
                <h3 className="text-sm text-center">Total Sign Ups</h3>
                <p className="text-sm text-primary font-semibold">5</p>
              </div>

              <div className="flex flex-col items-center py-2">
                <h3 className="text-sm text-center">Successful Referrals</h3>
                <p className="text-sm text-primary font-semibold">2</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <ReferralStep />
      </div>

      <Drawer open={openDrawer} onOpenChange={setOpenDrawer}>
        <DrawerContent>
          <div className="mx-auto w-full flex flex-row px-4 pb-8 overflow-auto hide-scrollbar">
            {actions.map((action, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col items-center gap-3 py-2 px-3 cursor-pointer hover:bg-slate-100 rounded-md"
                  onClick={action.onClick}
                >
                    <div className='size-12 bg-white rounded-full p-2 shadow-lg shadow-black/30 flex items-center justify-center'>
                      {action.image ? (
                        <img src={action.image} alt={action.title} className="w-12 h-12 min-w-12 rounded-full" />
                      ) : action.icon && (
                        <action.icon className="text-foreground/80 size-6" />
                      )}
                    </div>

                  <p className="text-xs font-light text-center">{action.title}</p>
                </div>
              );
            })}
          </div>
        </DrawerContent>
      </Drawer>

      <Toaster />
    </>
  )
}

export default Referral